<script lang="ts" setup>
const props = defineProps<{
  url: string;
  alt: string;
  preview?: boolean;
}>();

const config = useRuntimeConfig();
const { t } = useI18n();

const loaded = ref(false);
const height = ref(0);
const width = ref(0);

const aspectRatioStyle = ref<string>();

const onCompleted = (image: HTMLImageElement) => {
  width.value = image.width;
  height.value = image.height;

  aspectRatioStyle.value = `${width.value} / ${height.value}`;

  loaded.value = true;
};

if (import.meta.client) {
  const image = new Image();

  image.onload = () => onCompleted(image);

  image.src = props.url;

  if (image.complete) onCompleted(image);
}
</script>

<template>
  <BaseToggleTransition>
    <Image
      v-if="loaded"
      :preview="preview"
      :src="url"
      class="block!"
      :preview-button-props="{ 'aria-label': t('zoom_image_button') }"
      :pt="{
        image: { width, style: { 'aspect-ratio': aspectRatioStyle } },
      }"
      data-test-id="task-media"
    >
      <template #original="imgProps">
        <img :src="url" :alt="alt" class="relative z-1" v-bind="imgProps" />

        <Card
          @click.stop
          class="w-fit mx-auto mt-3"
          :pt="{
            body: 'p-3',
            content: 'flex flex-col',
          }"
        >
          <template #content>
            <span class="text-center">
              {{ t('shorts_hint.title') }}
              <br />
              {{ t('shorts_hint.description') }}
            </span>
            <Button
              as="nuxt-link"
              :to="config.public.services.shorts"
              external
              target="_blank"
              :label="t('shorts_hint.action')"
              outlined
              class="mt-3 w-full"
            />
          </template>
        </Card>
      </template>
    </Image>
  </BaseToggleTransition>
</template>

<i18n>
en:
  zoom_image_button: Zoom image
  shorts_hint:
    title: Like the images?
    description: Then go to Sex Shorts!
    action: Visit

ru:
  zoom_image_button: Увеличить изображение
  shorts_hint:
    title: Нравятся изображения?
    description: Тогда заходи на Sex Shorts!
    action: Перейти

de:
  zoom_image_button: Bild vergrößern
  shorts_hint:
    title: Gefallen Ihnen die Bilder?
    description: Dann komm zu Sex Shorts!
    action: Gehen

es:
  zoom_image_button: Ampliar imagen
  shorts_hint:
    title: ¿Te gustan las imágenes?
    description: ¡Entonces ven a Sex Shorts!
    action: Ir

fr:
  zoom_image_button: Agrandir l'image
  shorts_hint:
    title: Aimez-vous les images?
    description: Alors venez chez Sex Shorts!
    action: Aller
</i18n>
